import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import DataSeances from './DataSeances.json';
import DataUtilisateurs from './DataUtilisateurs.json';
import DataEntreprises from './DataEntreprises.json';
import DataActivites from './DataActivites.json';
import DataRating from './DataRating.json';
import DataTypes from './DataTypes.json';

function LoadDataToLocalStorage() {
    useEffect(() => {
        localStorage.setItem('seancesData', JSON.stringify(DataSeances));
        localStorage.setItem('utilisateursData', JSON.stringify(DataUtilisateurs));
        localStorage.setItem('entreprisesData', JSON.stringify(DataEntreprises));
        localStorage.setItem('activitesData', JSON.stringify(DataActivites));
        localStorage.setItem('ratingsData', JSON.stringify(DataRating));
        localStorage.setItem('typesData', JSON.stringify(DataTypes));
    }, []);

    return (
        <div className="flex-col">
            <h1>Les données ont été chargées dans le localStorage.</h1>
            <Link to="/accueil">accueil</Link>
            <Link to="/login">Se connecter</Link>
            <Link to="/password-reset">Mot de passe oublié</Link>
            <Link to="/password-reset">Se déconnecter</Link>
            <Link to="/">/</Link>
            <Link to="/seances/enregistrees">Mes séances enregistrées</Link>
            <Link to="/activites/myCompany">Activites de mon entreprise</Link>
        </div>
    );
}

export default LoadDataToLocalStorage;
